import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Logo from './images/logotipo-ASL-Softhouse-azul.png';
import IconLogout from './images/Icons/Slot.svg';
import IconConfig from './images/Icons/icone-config.svg';
import addImage from './images/addImage.svg';
import addQrCode from './images/addQrCode.svg';
import IconUser from './images/Icons/UserRounded_black.svg';
import { ServiceLogin } from './service/Login'; // no topo do arquivo
import { Dialog } from 'primereact/dialog'; 
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { RadioButton } from 'primereact/radiobutton';
import { InputSwitch } from "primereact/inputswitch";
import { Dropdown } from "primereact/dropdown";
import { ColorPicker } from 'primereact/colorpicker';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { ServiceApi } from "./service/Api";
import { ServiceConfig } from './service/Config';
class AppTopbar extends Component {

    static defaultProps = {
        onToggleMenu: null
    }

    static propTypes = {
        onToggleMenu: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props);

        this.state = {
            UsuarioNome: ''
        };
    }

    componentDidMount() {
        const nomeBruto = ServiceLogin.getUserName();
        const nomeFormatado = nomeBruto.charAt(0).toUpperCase() + nomeBruto.slice(1).toLowerCase();
        this.setState({
            UsuarioNome: nomeFormatado
        });
    }

    render() {

        const auth = JSON.parse(sessionStorage.getItem('auth'));
        const isAcessoCompartilhado = auth.TokenPortal ? true : false;
        const ismedico = auth.IdMedico !== 0 ? true : false;

        return (
            <div>
                <div id="pgrBar">%</div>
                <div className="app-header">
                    <div>
                        <img onClick={e => { { this.acessoSiteAsl(); } }} src={Logo} className="app-header__logo" />
                    </div>

                    <div className="app-header__actions">

                        {(!isAcessoCompartilhado) && (
                            <button className="app-header__button-user">
                                <img src={IconUser} />
                                <p className="app-header__button-text">
                                    {this.state.UsuarioNome
                                        .toLowerCase()
                                        .split(' ')
                                        .map(palavra => palavra.charAt(0).toUpperCase() + palavra.slice(1))
                                        .join(' ')
                                    }
                                </p>
                            </button>
                        )}

                        {!isAcessoCompartilhado && (
                            <button
                                className="app-header__button-logout"
                                onClick={() => {
                                    sessionStorage.clear();     // limpa tudo que tiver no sessionStorage
                                    ServiceLogin.logout();      // faz o logout normalmente
                                    window.location.reload();   // Realiza um update forçado na tela pra limpar as informações.
                                }}
                            >
                                <p className="app-header__button-text">Sair da Conta</p>
                                <img src={IconLogout} />
                            </button>
                        )}

                        {isAcessoCompartilhado && (<div>
                            <div className="app-header__button-user">
                                <img src={IconUser} />
                                <p className="app-header__button-text">
                                    Convidado
                                </p>
                            </div>
                        </div>)}
                    </div>
                </div>
            </div>
        );
    }
}


export default connect()(AppTopbar);